// removed by extract-text-webpack-plugin
module.exports = {"input-number-wrapper":"inputNumber__input-number-wrapper___14-XN","input-number-btn":"inputNumber__input-number-btn___3HA9Z","input-number-btn-minus":"inputNumber__input-number-btn-minus___1rVF5","input-number-btn-plus":"inputNumber__input-number-btn-plus___2rIey","input-number-input":"inputNumber__input-number-input___1swYU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/inputNumber.less
// module id = 1150
// module chunks = 3